/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GENERATE_INVOICE_SEARCH_TAB_DATA =
  'GENERATE_INVOICE_SEARCH_TAB_DATA';
export const HANDLE_ERROR_MESSAGE_FOR_G_INV = 'HANDLE_ERROR_MESSAGE_FOR_G_INV';
export const PERV_SEARCH_SCREEN_DATA = 'PERV_SEARCH_SCREEN_DATA';
export const GET_COMMON_DROPDOWN_DATA_G_INV = 'GET_COMMON_DROPDOWN_DATA_G_INV';
export const GET_QUARTER_DATA_G_INV = 'GET_QUARTER_DATA_G_INV';
export const GET_PLAN_TYPE_DATA_G_INV = 'GET_PLAN_TYPE_DATA_G_INV';
export const GET_SEARCH_G_INV_BY_CRITERIA = 'GET_SEARCH_G_INV_BY_CRITERIA';
export const GENERATE_INVOICE_DETAIL_TAB_DATA =
  'GENERATE_INVOICE_DETAIL_TAB_DATA';
export const GET_RUN_NOW_GI = 'GET_RUN_NOW_GI';
export const PDF_RUN_NOW_GI = 'PDF_RUN_NOW_GI';
export const UPDATE_CUSTOMIZE_LETTER = 'UPDATE_CUSTOMIZE_LETTER';
export const GET_PLAN_TYPE_USING_REBATE_PROG =
  'GET_PLAN_TYPE_USING_REBATE_PROG';
export const SAVE_FAILED_INVOICES = 'SAVE_FAILED_INVOICES';
